import Http from "../utilities/Http";
import {API_ROOT} from "../config";

export default {
	async getOrganizationRoles(organizationId) {
		let response = await Http().get(API_ROOT + '/organizations/' + organizationId + '/roles');

		return response.data.roles;
	},

	async getRolePermissions(organizationId) {
		let response = await Http().get(API_ROOT + '/organizations/' + organizationId + '/roles/permissions');

		return response.data.permissions;
	},
	async insertRole(organizationId, organizationRole, users) {
		const response = await Http().post(`${API_ROOT}/organizations/${organizationId}/roles`, {
			organizationRole,
			users
		});

		return response.data.organizationRole;
	},
	async updateRole(organizationId, organizationRoleId, organizationRole, users, cancelToken = null) {
		const response = await Http().post(`${API_ROOT}/organizations/${organizationId}/roles/${organizationRoleId}`, {
				organizationRole,
				users
			},
			{cancelToken}
		);

		return response.data.organizationRole;
	},
	async deleteRole(organizationId, organizationRoleId) {
		const response = await Http().delete(`${API_ROOT}/organizations/${organizationId}/roles/${organizationRoleId}`);
	}
};
